import { render, staticRenderFns } from "./MyTaskClosed.vue?vue&type=template&id=2096f740"
import script from "./MyTaskClosed.vue?vue&type=script&lang=js"
export * from "./MyTaskClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports